import { getMyClients } from '../../enrollment-platform/api/persons'
import { fetchOpenableAncillaryReportClients } from '../../enrollment-platform/pages/AncillaryReport/api/ancillary-report.api'
import {
  AncillaryReportTab,
  CensusMgmtV2Tab,
  CustomerManagementTab,
  DataAndReportsTab,
  EnrollmentDashboardTab,
  PlanManagementV3Tab,
  QLETab,
} from './link-data'

// Check the flag for census-v2. This contains a list of clients for which v2 is enabled.
// If the user's administered-clients has a client id within the census-v2 flag list,
// this user can see the census-v2 link.
async function hasCensusV2LinkAccess(flags: Record<string, any>) {
  const canUseCensusV2ClientIds =
    flags['ui.admin.enable-census-v2-for-client'] ?? []
  const myClients = await getMyClients()
  return myClients.some((client) => canUseCensusV2ClientIds.includes(client.id))
}

export const getFlagBasedAdminLinks = async (flags: Record<string, any>) => {
  const links = [
    flags['admin.show-reports-tab-to-hr-users'] ? DataAndReportsTab : null,
    flags['admin.show-enrollment-dashboard'] ? EnrollmentDashboardTab : null,
    flags['ui.customer.new-experience'] ? CustomerManagementTab : null,
  ].filter(Boolean)
  const hasCensusV2Access = await hasCensusV2LinkAccess(flags)

  if (hasCensusV2Access) {
    links.push(CensusMgmtV2Tab)
  }

  return links
}

// Client admins only. `getFlagBasedAdminLinks` is shared with brokers, who
// cannot open the ancillary report. The ancillary report is gated by a
// per-customer configuration that EPS resolves.
export const getFlagBasedClientAdminLinks = async () => {
  try {
    const myClients = await getMyClients()
    const ancillaryReportClients = await fetchOpenableAncillaryReportClients(
      myClients.map((client) => client.id)
    )
    return ancillaryReportClients.length > 0 ? [AncillaryReportTab] : []
  } catch {
    return []
  }
}

export const getFlagBasedHixmeAdminLinks = async (
  flags: Record<string, any>
) => {
  return [...(flags['qle-v-1'] ? [QLETab] : []), PlanManagementV3Tab].filter(
    Boolean
  )
}
